(function () {
  if (window.cardSizeSelectionBound) return;
  window.cardSizeSelectionBound = true;

  document.addEventListener("click", function (event) {
    const button = event.target.closest(".card__size-button");
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    addSizeToCart(button);
  });
})();

function addSizeToCart(button) {
  const variantId = button.dataset.variantId;
  if (!variantId) return;

  button.disabled = true;
  button.classList.add("adding");

  const cart = document.querySelector("cart-drawer");
  const sections = cart
    ? cart.getSectionsToRender().map((section) => section.id)
    : [];

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: sections.join(","),
      sections_url: window.location.pathname,
    }),
  })
    .then((response) =>
      response.json().then((data) => ({ ok: response.ok, data })),
    )
    .then(({ ok, data }) => {
      if (!ok || data.status) {
        throw new Error(data.description || data.message || "Sepete eklenemedi");
      }
      if (cart && data.sections) {
        cart.classList.remove("is-empty");
        cart.renderContents(data);
        return;
      }
      window.location.href = "/cart";
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      button.disabled = false;
      button.classList.remove("adding");
    });
}
